import { FormGroup } from '@angular/forms';

export function markAllAsTouched(form: any) {
    Object.values(form.controls).forEach((control: any) => {
      if (control instanceof FormGroup) {
        Object.values(control.controls).forEach(innerControl => innerControl.markAsTouched()); // Mark inner controls as touched
      } else {
        control.markAsTouched(); // Mark control as touched
      }
    });
}